import { isString, isArray } from "@vue/shared";
import { buildProps } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";

export const searchMoreProps = buildProps({
  modelValue: {
    type: String,
    required: true,
  },
  morePlaceholder: {
    type: String,
  },
  disabledRows: {
    type: Number,
    default: 200,
  },
} as const);
export type SearchMoreProps = ExtractPropTypes<typeof searchMoreProps>;
export const searchMoreEmits = {
  "update:modelValue": (value: string) => isString(value),
  change: (value: string[]) => isArray(value),
};
export type SearchMoreEmits = typeof searchMoreEmits;
